module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Импорт откликов","title":"Интеграция с Job-сайтами","edit":"Редактировать","thisVacancy":"Эта вакансия на"}}')
  delete Component.options._Ctor
}
